import { useEffect } from "react";

const LOCKED_VIEWPORT = "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no";
const PREVIEW_VIEWPORT = "width=device-width, initial-scale=1, maximum-scale=5, user-scalable=yes";

// 浏览器原生缩放作用于整个文档；仅在照片预览打开期间临时启用它。
export function usePreviewViewportZoom(open) {
    useEffect(() => {
        const viewport = document.querySelector('meta[name="viewport"]');
        if (!viewport) {
            return undefined;
        }

        const previousContent = viewport.getAttribute("content") || LOCKED_VIEWPORT;
        viewport.setAttribute("content", open ? PREVIEW_VIEWPORT : LOCKED_VIEWPORT);

        return () => {
            viewport.setAttribute("content", previousContent);
        };
    }, [open]);
}
